import { thirdly2 } from "styles/theme"

const roles = {
    coordinator: "coordinator",
    teacher: "teacher",
    principal: "principal",
    single: "single",
    all: "all",
}

const roleKeys = {
    super_user: "super_user",
    student: "student",
    external_learning_center_private_teacher: "external_learning_center_private_teacher",
    clinic_manager: "clinic_manager",
    coordinator: "coordinator",
    grade_reading_support_teacher: "grade_reading_support_teacher",
    instructional_coordinator: "instructional_coordinator",
    reading_intervention_teacher: "reading_intervention_teacher",
    homeroom_teacher: "homeroom_teacher",
    grade_coordinator: "grade_coordinator",
    private_teacher: "private_teacher",
    external_learning_center_teacher: "external_learning_center_teacher",
    teacher: "teacher",
    principal: "principal",
    checker: "checker",
    assessments_operator: "assessments_operator",
    municipal_language_instruction_coordinator: "municipal_language_instruction_coordinator",
    school_reading_coordinator: "school_reading_coordinator",
    grade_language_coordinator: "grade_language_coordinator",
    teaching_assistant: "teaching_assistant",
    external_learning_center_class_teacher: "external_learning_center_class_teacher",
    supervisor: "supervisor",
    school_secretary: "school_secretary",
    parent: "parent",
    school_setup: "school_setup",
    ICT_coordinator: "ICT_coordinator",

    municipal_pedagogy_manager: "municipal_pedagogy_manager",
    external_learning_center_grade_teacher: "external_learning_center_grade_teacher"
}

const roleItems = {
    [roleKeys.supervisor]: {
        color: "pink2"
    },
    [roleKeys.checker]: {
        color: "pink3"
    },
    [roleKeys.clinic_manager]: {
        color: "pink4"
    },
    [roleKeys.coordinator]: {
        color: "pink5"
    },
    [roleKeys.teaching_assistant]: {
        color: "green2"
    },
    [roleKeys.instructional_coordinator]: {
        color: "green3"
    },
    [roleKeys.reading_intervention_teacher]: {
        color: "green4"
    },
    [roleKeys.homeroom_teacher]: {
        color: "green5"
    },
    [roleKeys.grade_coordinator]: {
        color: "green6"
    },
    [roleKeys.grade_coordinator]: {
        color: "green7"
    },
    [roleKeys.school_setup]: {
        color: "error"
    },
    [roleKeys.private_teacher]: {
        color: "lightBlue"
    },
    [roleKeys.teacher]: {
        color: "lightBlue2"
    },
    [roleKeys.principal]: {
        color: "lightBlue3"
    },
    [roleKeys.municipal_language_instruction_coordinator]: {
        color: "lightBlue4"
    },
    [roleKeys.school_reading_coordinator]: {
        color: "gray2"
    },
    [roleKeys.grade_language_coordinator]: {
        color: "gray3"
    },
    [roleKeys.grade_reading_support_teacher]: {
        color: "orange"
    },
    [roleKeys.school_secretary]: {
        color: "orange2"
    },
    [roleKeys.assessments_operator]: {
        color: "orange3"
    },
    [roleKeys.parent]: {
        color: "orange4"
    },
    [roleKeys.ICT_coordinator]: {
        color: "purple"
    },
    [roleKeys.external_learning_center_teacher]: {
        color: "purple2"
    },
    [roleKeys.municipal_pedagogy_manager]: {
        color: "purple3"
    },
    [roleKeys.external_learning_center_private_teacher]: {
        color: "purple4"
    },
    [roleKeys.external_learning_center_class_teacher]: {
        color: "pink3"
    },
    [roleKeys.external_learning_center_grade_teacher]: {
        color: "orange4"
    }
}

const allRoles = {
    [roleKeys.supervisor]: roles.principal,
    [roleKeys.checker]: roles.all,
    [roleKeys.clinic_manager]: roles.principal,
    [roleKeys.coordinator]: roles.coordinator,
    [roleKeys.teaching_assistant]: roles.teacher,
    [roleKeys.instructional_coordinator]: roles.coordinator,
    [roleKeys.reading_intervention_teacher]: roles.single,
    [roleKeys.homeroom_teacher]: roles.teacher,
    [roleKeys.grade_coordinator]: roles.coordinator,
    [roleKeys.school_setup]: roles.principal,
    [roleKeys.private_teacher]: roles.single,
    [roleKeys.teacher]: roles.teacher,
    [roleKeys.principal]: roles.principal,
    [roleKeys.municipal_language_instruction_coordinator]: roles.coordinator,
    [roleKeys.school_reading_coordinator]: roles.principal,
    [roleKeys.grade_language_coordinator]: roles.coordinator,
    [roleKeys.grade_reading_support_teacher]: roles.coordinator,
    [roleKeys.school_secretary]: roles.principal,
    [roleKeys.assessments_operator]: roles.principal,
    [roleKeys.parent]: roles.single,
    [roleKeys.ICT_coordinator]: roles.principal,
    [roleKeys.external_learning_center_teacher]: roles.principal,
    [roleKeys.municipal_pedagogy_manager]: roles.principal,
    [roleKeys.external_learning_center_private_teacher]: roles.single,
    [roleKeys.external_learning_center_class_teacher]: roles.teacher,
    [roleKeys.external_learning_center_grade_teacher]: roles.coordinator
}

const openRoles = [roleKeys.principal, roleKeys.school_setup, roleKeys.teacher, roleKeys.ICT_coordinator, roleKeys.school_reading_coordinator, roleKeys.assessments_operator]

export { openRoles, roleItems, allRoles, roleKeys as roleNames, roles as roleTypes }
export default roles
